import {
	ADMINADDORUPDATEFEE_SUCCESS,
	ADMINADDORUPDATEFEE_FAILED,
	RESET_ADMINADDORUPDATEFEE,
	LOADING_ADMINADDORUPDATEFEE,
	NETWORK_ERROR_ADMINADDORUPDATEFEE
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINADDORUPDATEFEE:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINADDORUPDATEFEE_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINADDORUPDATEFEE_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINADDORUPDATEFEE:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINADDORUPDATEFEE:
			return (state = initialState);
		default:
			return state;
	}
};
